import { defineFetch } from 'resift';

const makeGetAttributeAutocomplete = defineFetch({
  displayName: 'Get Attribute Autocomplete',
  make: () => ({
    key: [],
    request: (fieldId: string) => ({ http }) =>
      http({
        method: 'GET',
        route: `/fields/${fieldId}/autocomplete`,
        query: { retrieveAllDatabaseEntries: true },
      }),
  }),
});

export default makeGetAttributeAutocomplete;
